import { FC, useContext, useEffect, useState } from 'react';
import { UnauthAppFooter } from 'templates/UnauthAppFooter';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { GetPageProps, UserRegistrationState } from 'hooks/u002/useUserRegistrationHooks';
import { ConsentContent } from 'templates/ConsentContent';
import { TermOfServiceConsent as TermOfServiceConsentValue } from 'domains/User';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { Controller } from 'react-hook-form';
import { useGetAgreementText } from 'hooks/u002/useGetAgreementTextHooks';
import MessageModal from 'organisms/MessageModal';
import LoadingModal from 'organisms/LoadingModal';
import { AppContext } from 'templates/AppContextProvider';
import { GetAuditionResponse } from 'hooks/u002/useGetAuditionHooks';

//U002F02 利用規約同意画面
type TermOfServiceConsentProps = GetPageProps<UserRegistrationState, 'TermOfServiceConsent'> & {
  audition: GetAuditionResponse & {
    audition_id: string;
    examination_no: number;
  };
};
export const TermOfServiceConsent: FC<TermOfServiceConsentProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const { userId, currentLang } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');
  const [termOfServiceConsent, loading, err] = useGetAgreementText({
    user_id: userId,
    audition_id: props.audition.audition_id,
    examination_no: props.audition.examination_no,
    lang: currentLang,
    consent_type: '0', // 0: 利用規約
  });

  const handleBack = () => props.onBack();
  const handleNext = () => props.onNext();

  const { control } = props;

  const handleChange =
    (onChange: (value: TermOfServiceConsentValue) => void) => (checked: boolean) => {
      onChange(checked ? TermOfServiceConsentValue.Yes : TermOfServiceConsentValue.No);
    };

  useEffect(() => {
    if (err?.message) {
      setErrorMessage(tAuditionForm('TU002_050'));
    }
  }, [err]);

  return (
    <>
      {loading && <LoadingModal />}
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tAuditionForm('TU002_032')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <AppLogoHeader />
      <Controller
        control={control}
        name="term_of_service_consent"
        render={({ field: { onChange, value } }) => {
          const checked = value === TermOfServiceConsentValue.Yes;
          return (
            <ConsentContent
              title={tAuditionForm('TU002_003')}
              text={termOfServiceConsent?.consent_text}
              label={tAuditionForm('TU002_040')}
              nextLabel={tAuditionForm('TU002_041')}
              backLabel={tAuditionForm('TU002_042')}
              checked={checked}
              onChange={handleChange(onChange)}
              onBack={handleBack}
              onNext={handleNext}
            />
          );
        }}
      />
      <UnauthAppFooter />
    </>
  );
};
